module.exports = __webpack_public_path__ + "static/media/family_portrait.ad5cbb44.jpg";